import { gql } from '@apollo/client';

export const CREATE_REPORT_DEFINITION_SCHEDULE_RUN = gql`
    mutation createReportDefinitionScheduleRun($input: CreateReportDefinitionScheduleRun!) {
        facility {
            report {
                createDefinitionScheduleRun(input: $input) {
                    reportDefinitionId
                    reportDefinitionScheduleId
                    correlationId
                }
            }
        }
    }
`;
